import { ModuleStructure } from './../../models/module-structure';
import { RecordModel } from 'src/app/layout/record-model';
import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ViewChild,
  HostListener,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ModuleInformation } from 'src/app/models/module-information';
import { LayoutService } from '../layout.service';
import { Title } from '@angular/platform-browser';
import * as g from 'src/app/globals';
import { Observable, Subscription } from 'rxjs';
import { RecordsListComponent } from '../records-list/records-list.component';
import { NzModalService } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-module-list',
  templateUrl: './module-list.component.html',
  styleUrls: ['./module-list.component.less'],
})
export class ModuleListComponent implements OnInit, OnDestroy {
  NaN = NaN;
  recordPageInit = true;
  @ViewChild('recordPage') recordsListComponent: RecordsListComponent;
  selectedRecords: any[] = [];
  selectedRecordsFromCheckBox: string[] = [];
  moduleIdVal: string;
  objectDescription = '';
  newMode = false;
  fromDraft = false;
  fromDoc = false;
  moduleStructure: ModuleStructure;
  openedObjects: {
    moduleId: string;
    recordId: string;
    title: string;
    selected: boolean;
    fullTitle?: string;
    moduleFilterId: number;
  }[] = [];
  pageHeaderAffix: boolean;
  showSuccessArea: boolean;

  @Input() set moduleId(value: string) {
    this.moduleIdVal = value;
  }
  get moduleId(): string {
    return this.moduleIdVal;
  }

  private _customUrlPrefix = '';
  get customUrlPrefix() {
    return this._customUrlPrefix;
  }
  @Input() set customUrlPrefix(value: string) {
    this._customUrlPrefix = value;
    this.urlPrefix = this.customUrlPrefix;
  }
  moduleFilterId = 0;
  sourceModuleId = '0';

  app = '';
  urlPrefix = '';
  displayOpenedObjectHistory = g.displayOpenedObjectHistory;

  actionType: string;
  moduleActionType: number;
  inDrawer: boolean;
  sourceObject: number;
  sourceObjectId: string | number;
  customActionCode: string;

  moduleInformation: ModuleInformation;
  subscriptions: Subscription[] = [];
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private layoutService: LayoutService,
    private modal: NzModalService,
    private title: Title,
  ) {}

  ngOnDestroy(): void {
    this.layoutService.containerTransparentBGEmitter.emit(false);
    this.layoutService.containerFooterLeftPaddingEmitter.emit(0);
    this.title.setTitle(g.getTitleSuffix());
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    if (this.layoutService.recordModelChanged) {
      return false;
    } else {
      return true;
    }
  }

  ngOnInit(): void {
    this.layoutService.containerTransparentBGEmitter.emit(true);
    this.layoutService.containerFooterLeftPaddingEmitter.emit(12.5);

    this.layoutService.createNewEmitter.subscribe((a) => {
      this.showSuccessArea = false;
    });

    let savedTabs = localStorage.getItem(
      'openedTabs-' + g.userIdentity.UserCode + '-' + g.userIdentity.CompanyDB,
    );
    if (savedTabs == null || savedTabs === '') {
      savedTabs = '[]';
    }

    this.openedObjects = JSON.parse(savedTabs);

    this.app = this.route.snapshot.data.app;
    if (this.app == null) {
      // get the url segment after the first slash and before modue-list
      const url = this.router.url;
      const urlParts = url.split('/');
      const moduleListIndex = urlParts.indexOf('module-list');
      if (moduleListIndex > 0) {
        this.app = `/${[...urlParts.slice(2, moduleListIndex)].join('/')}`;
      }
    }

    if (g.currentAppPrefix === '' && this.customUrlPrefix == '') {
      this.urlPrefix = `/apps/${this.app}/`;
    } else if (g.currentAppPrefix == '' && this.customUrlPrefix != '') {
      this.urlPrefix = this.customUrlPrefix;
    } else {
      this.urlPrefix = g.currentAppPrefix;
    }

    const params$ = this.route.params.subscribe((data) => {
      const modId = data.moduleId ?? this.moduleId;
      this.recordPageInit = false;
      //debugger;
      this.layoutService
        .moduleInformation(modId)
        .subscribe((d: ModuleInformation) => {
          if (this.moduleId !== modId) {
            this.moduleId = undefined;
          }
          this.fromDraft = data.fromDraft === 'true' || data.fromDraft === true;
          this.fromDoc = data.fromDoc === 'true' || data.fromDoc === true;

          setTimeout(() => {
            if (this.moduleId !== modId) {
              this.selectedRecordsFromCheckBox = [];
              this.layoutService
                .getModuleStructure(modId)
                .subscribe((moduleStructure) => {
                  this.moduleStructure = moduleStructure;
                });
            }

            this.moduleId = modId;
            this.moduleFilterId = data.moduleFilterId;

            this.actionType = data.actionType;
            this.moduleActionType = data.moduleActionType;
            this.sourceObject = data.sourceObject;
            this.sourceObjectId = data.sourceObjectId;
            this.customActionCode = data.customActionCode;
            this.inDrawer = data.inDrawer;

            this.newMode = data.newMode === 'true' || data.newMode === true;
            if (data.selectedId == null) {
              this.selectedRecords = [];
              //this.recordSelected([]);
            }

            this.moduleInformation = d;
            if (this.newMode) {
              this.title.setTitle(
                `${
                  this.moduleInformation.CreateNewText
                } - ${g.getTitleSuffix()}`,
              );
            } else {
              this.title.setTitle(
                `${this.moduleInformation.PluralName} - ${g.getTitleSuffix()}`,
              );
            }
            this.recordPageInit = true;
          }, 10);
        });
    });
    this.subscriptions.push(params$);
  }

  recordSelected(selection: any[], setNewMode?): void {
    if (selection === undefined || this.moduleId === undefined) {
      return;
    }

    this.objectDescription = '';
    this.selectedRecords = selection;
    if (
      selection[0] === undefined ||
      selection === undefined ||
      selection.length === 0
    ) {
      this.selectedRecords = [];
      if ((this.newMode || setNewMode === true) && this.actionType != null) {
        this.recordPageInit = false;
        setTimeout(() => {
          this.router.navigate([
            `${this.urlPrefix}module-list/${this.moduleId}/${this.moduleFilterId}`,
            { newMode: true, fromDraft: this.fromDraft },
          ]);
          this.recordPageInit = true;
        }, 1);
      } else {
        if (this.sourceObject !== undefined && g.goToSourceList) {
          this.router.navigate([
            `${this.urlPrefix}module-list/${this.sourceObject}/${this.moduleFilterId}`,
            { fromDraft: this.fromDraft },
          ]);
          this.recordsListComponent.reloadTheRecords(false);
        } else {
          this.router.navigate([
            `${this.urlPrefix}module-list/${this.moduleId}/${this.moduleFilterId}`,
            { fromDraft: this.fromDraft },
          ]);
          this.recordsListComponent.reloadTheRecords(false);
        }
      }
    } else {
      if (this.moduleId === '10012') {
        this.router.navigate([`${this.urlPrefix}/ticket-page/${selection[0]}`]);
      } else {
        this.recordPageInit = false;
        setTimeout(() => {
          if (this.fromDoc) {
            this.router.navigate([
              `${this.urlPrefix}module-list/${this.moduleId}/${this.moduleFilterId}`,
              {
                selectedId: this.selectedRecords[0],
                fromDraft: this.fromDraft,
                fromDoc: this.fromDoc,
              },
            ]);
          } else {
            this.router.navigate([
              `${this.urlPrefix}module-list/${this.moduleId}/${this.moduleFilterId}`,
              {
                selectedId: this.selectedRecords[0],
                fromDraft: this.fromDraft,
              },
            ]);
          }

          this.openedObjects.forEach((e) => (e.selected = false));
          let openedObject = this.openedObjects.find(
            (a) =>
              a.recordId === this.selectedRecords[0].toString() &&
              a.moduleId === this.moduleId,
          );
          if (openedObject == null) {
            openedObject = {
              moduleId: this.moduleId,
              recordId: this.selectedRecords[0].toString(),
              title: null,
              selected: true,
              moduleFilterId: this.moduleFilterId,
            };

            this.openedObjects.push(openedObject);
          }

          openedObject.title = null;
          openedObject.selected = true;

          this.recordPageInit = true;
        }, 1);
      }
    }
  }

  navigateToNew() {
    this.router.navigate([
      `${this.urlPrefix}module-list/${this.moduleId}/${this.moduleFilterId}`,
      {
        newMode: true,
        fromDraft: this.fromDraft,
      },
    ]);
  }

  recordPageDrawerClosed() {
    this.selectedRecords = [];
    this.router.navigate([
      `${this.urlPrefix}module-list/${this.moduleId}/${this.moduleFilterId}`,
      { fromDraft: this.fromDraft },
    ]);
  }

  recordModelChanged(recordModel: RecordModel) {
    const recordDetailsFieldName =
      this.moduleStructure.module.AdditionalInformationParsed
        .RecordDetailsFieldName;

    if (recordDetailsFieldName != null && recordDetailsFieldName !== '') {
      this.objectDescription = recordModel.Categories.find(
        (f) => f.Id === recordDetailsFieldName.split('.')[0],
      ).Lines[0].Properties.find(
        (p) => p.Name === recordDetailsFieldName.split('.')[1],
      ).ValueAsObject;
    } else if (
      recordModel.Categories.find((f) => f.Id === 'Documents') !== undefined
    ) {
      if (recordModel.ObjectKey === 'BlanketAgreement') {
        this.objectDescription = recordModel.Categories.find(
          (f) => f.Id === 'BlanketAgreement',
        ).Lines[0].Properties.find((p) => p.Name === 'Number').ValueAsObject;
      } else {
        this.objectDescription = recordModel.Categories.find(
          (f) => f.Id === 'Documents',
        ).Lines[0].Properties.find((p) => p.Name === 'DocNum').ValueAsObject;
      }
    } else if (
      recordModel.Categories.find((f) => f.Id === 'ProductionOrders') !==
      undefined
    ) {
      this.objectDescription = recordModel.Categories.find(
        (f) => f.Id === 'ProductionOrders',
      ).Lines[0].Properties.find((p) => p.Name === 'DocNum').ValueAsObject;
    } else {
      this.objectDescription = this.selectedRecords[0];
    }

    if (!this.newMode) {
      const objectDesc = `${this.layoutService.translate(
        this.moduleInformation.Name + (this.fromDraft ? ' (Draft)' : ''),
      )} ${this.objectDescription}`;

      const tab = this.openedObjects.find(
        (a) =>
          a.recordId === this.selectedRecords[0].toString() &&
          a.moduleId === this.moduleId,
      );

      if (tab != null) {
        tab.title = this.objectDescription;
        tab.fullTitle = objectDesc;
      }

      localStorage.setItem(
        'openedTabs-' +
          g.userIdentity.UserCode +
          '-' +
          g.userIdentity.CompanyDB,
        JSON.stringify(this.openedObjects),
      );
      this.title.setTitle(`${objectDesc} - ${g.getTitleSuffix()}`);
    }
  }

  navigateToObj(obj) {
    this.moduleId = obj.moduleId;
    this.router.navigate([
      `${this.urlPrefix}module-list/${obj.moduleId}/${obj.moduleFilterId}`,
      {
        selectedId: obj.recordId,
        fromDraft: this.fromDraft,
      },
    ]);
  }

  deleteObj(obj) {
    const index = this.openedObjects.indexOf(obj);
    this.openedObjects.splice(index, 1);

    if (
      this.moduleId === obj.moduleId &&
      this.selectedRecords[0].toString() === obj.selectedId
    ) {
      this.router.navigate([
        `${this.urlPrefix}module-list/${obj.moduleId}/${obj.moduleFilterId}`,
        { fromDraft: this.fromDraft },
      ]);
    }

    localStorage.setItem(
      'openedTabs-' + g.userIdentity.UserCode + '-' + g.userIdentity.CompanyDB,
      JSON.stringify(this.openedObjects),
    );
  }

  pageHeaderAffixChanged(newValue: boolean) {
    this.pageHeaderAffix = newValue;
  }

  objectSubmitted(selectedId: any) {
    if (this.newMode) {
      const additionalInformation =
        this.moduleStructure.module.AdditionalInformationParsed;
      if (additionalInformation.DisplaySuccessMessageAfterAdd) {
        this.showSuccessArea = true;
      } else if (additionalInformation.AfterCreateGoToNew) {
        this.recordPageInit = false;
        setTimeout(() => {
          this.recordPageInit = true;
        }, 1);
      } else {
        this.newMode = false;
        if (selectedId != null) this.recordSelected([selectedId]);
        else this.recordSelected([]);
      }
    } /*else {
      if (this.moduleStructure.module.GoBackAfterAdd) {
        this.goBack();
      }
    }*/
  }

  selectRecordFromCheckBoxChanged(event) {
    this.selectedRecordsFromCheckBox = event;
  }

  goBack() {
    /*if (this.layoutService.cancelClicked) {
      return;
    }*/
    //this.newMode = false;
    //this.recordSelected([]);
    if (this.fromDoc) {
      this.router
        .navigate([
          `${this.urlPrefix}module-list/${this.moduleId}/${this.moduleFilterId}`,
          {
            fromDraft: false,
          },
        ])
        .then((x) => {
          //console.log(x);
          if (x) {
            this.layoutService.recordModelChanged = false;
            this.newMode = false;
          }
        });
    } else {
      if (this.customActionCode === 'OFFLOAD_TO_GRPO') {
        this.router
          .navigate([
            `${this.urlPrefix}module-list/${this.sourceObject}/${this.moduleFilterId}`,
            {
              fromDraft: this.fromDraft,
            },
          ])
          .then((x) => {
            //console.log(x);
            if (x) {
              this.layoutService.recordModelChanged = false;
              this.newMode = false;
            }
          });
      } else if (this.sourceObject !== undefined && g.goToSourceList) {
        this.router
          .navigate([
            `${this.urlPrefix}module-list/${this.sourceObject}/${this.moduleFilterId}`,
            {
              fromDraft: this.fromDraft,
            },
          ])
          .then((x) => {
            //console.log(x);
            if (x) {
              this.layoutService.recordModelChanged = false;
              this.newMode = false;
            }
          });
      } else {
        this.router
          .navigate([
            `${this.urlPrefix}module-list/${this.moduleId}/${this.moduleFilterId}`,
            {
              fromDraft: this.fromDraft,
            },
          ])
          .then((x) => {
            //console.log(x);
            if (x) {
              this.layoutService.recordModelChanged = false;
              this.newMode = false;
            }
          });
      }
    }
  }
}
